<template>
  <div class="user-select">
    <el-popover
      ref="popRef"
      placement="bottom"
      popper-class="user-select-popper"
      trigger="manual"
      :visible="visible"
      width="240"
      @hide="handleHide"
    >
      <div
        v-if="userList.length"
        class="user-select-content"
        :style="{ height: userList.length > 9 ? '300px' : 'auto' }"
      >
        <el-scrollbar v-loading="searchLoading" style="height: 100%">
          <div
            v-for="item in userList"
            :key="item.id"
            class="user-item"
            @click="handleSelectUser(item)"
          >
            <img
              v-if="item.avatar && !item.avatar.includes('default.jpg')"
              alt=""
              class="avatar"
              :src="item.avatar"
            />
            <img v-else alt="" class="avatar" :src="userDefault" />
            <span v-html="addNodeByWX(item.name)"></span>
          </div>
        </el-scrollbar>
      </div>
      <div v-else v-loading="searchLoading" class="user-select-empty">未找到该员工</div>
      <template #reference>
        <div>
          <el-input
            v-model="name"
            clearable
            :placeholder="placeholder"
            :prefix-icon="Search"
            @clear="handleClearSearch"
            @click.stop="visible = !visible"
            @input="handleSearchInput"
          >
          </el-input>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script setup>
import { geuUserList } from '@/api/ai-board'
import { ref, onMounted, watch, nextTick } from 'vue'
import { Search } from '@element-plus/icons-vue'
import userDefault from '@/assets/user-default.png'
import { addNodeByWX } from '@/utils/wx-node.js'

defineOptions({
  name: 'UserSelect'
})

const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  },
  departmentId: {
    type: [Number, String],
    default: ''
  },
  isReview: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请输入员工名称'
  }
})

const emits = defineEmits(['update:value', 'selectUser'])

const popRef = ref(null)
const visible = ref(false)

const searchLoading = ref(false)
const thisSelect = ref(false)
const userList = ref([])
const timeout = ref(null)
const name = ref('')
const nameChange = ref(false)

const getUserList = (name) => {
  const params = {
    pageSize: 20,
    page: 1,
    nameLike: name && name.trim()
  }
  if (!props.isReview) {
    params.assistantAlias = 'meeting'
  }
  geuUserList(params)
    .then((res) => {
      userList.value = res.result.userList
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      searchLoading.value = false
    })
}

const handleSelectUser = (item) => {
  name.value = item.name
  thisSelect.value = true
  emits('update:value', item.userId)
  emits('selectUser', item)
  nextTick(() => {
    console.log(popRef.value)
    // popRef.value.doClose()
    popRef.value.hide()
    visible.value = false
    nameChange.value = false
    getUserList()
  })
}

const handleClearSearch = () => {
  name.value = ''
  emits('update:value', '')
  emits('selectUser', null)
}

const handleClear = () => {
  name.value = ''
  if (!name.value) {
    return
  }
  emits('update:value', '')
  emits('selectUser', null)
}

const handleSearch = () => {
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getUserList()
  }, 500)
}
const handleHide = () => {
  if (!thisSelect.value && nameChange.value) {
    handleClear()
    nameChange.value = false
    handleSearch()
  } else {
    thisSelect.value = false
  }
}

const handleSearchInput = () => {
  searchLoading.value = true
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getUserList(name.value)
  }, 500)
}

watch(
  () => name.value,
  () => {
    nameChange.value = true
  }
)

watch(
  () => props.value,
  (val) => {
    if (!val) {
      name.value = ''
    }
  }
)

onMounted(() => {
  getUserList()
})
defineExpose({
  visible
})
</script>

<style lang="scss" scoped>
.user-select {
  :deep(.el-input) {
    width: 240px;
  }
}
</style>

<style lang="scss">
.user-select-content {
  .user-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    .avatar {
      flex: 0 0 auto;
      margin-right: 8px;
    }
    img {
      width: 24px;
      height: 24px;
      border-radius: 4px;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .user-item:hover {
    cursor: pointer;
    background: #f7f8fa;
  }
}
.user-select-empty {
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #969799;
}
</style>
